import { Modal } from '@mui/material';
import React, { useState } from 'react';
import { X } from 'react-feather';
import { COLORS } from '../../../../utils/colors';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { AppButton } from '../../../general/AppButton/AppButton';

const AddStepModal = ({
  open,
  handleClose,
  onSubmit,
  stepName,
}: {
  open: boolean;
  handleClose: () => void;
  onSubmit: (data: { name: string; id: string }) => void;
  stepName?: string | null;
}) => {
  const [fieldName, setFieldName] = useState('');
  const [fieldError, setFieldError] = useState('');

  const handleCloseModal = () => {
    setFieldName('');
    handleClose();
  };

  React.useEffect(() => {
    if (stepName && open) {
      setFieldName(stepName);
    }
  }, [stepName, open]);

  const handleSubmit = () => {
    if (fieldName.trim() === '') {
      setFieldError('Step name is required');
      return;
    }
    const data = {
      name: fieldName.trim(),
      id: fieldName.trim().toLowerCase().replace(/\s+/g, '-'),
    };
    onSubmit(data);
    handleCloseModal();
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div
        style={{ maxHeight: '90vh' }}
        className="flex min-h-50  w-4/12 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg  flex-col overflow-hidden">
        <div className="sticky top-0 z-10 bg-white py-2 px-4">
          <X
            className="absolute right-2 top-2 cursor-pointer"
            color={COLORS.GREY_500}
            onClick={handleCloseModal}
          />
          <h3 className="text-lg font-bold ">Add Step</h3>
        </div>
        <div className="flex flex-col mt-4 GREY_400-BORDER border-y p-4">
          <AppInputField
            isRequired
            placeholder="Enter step name"
            label="Step Name"
            errorText={fieldError}
            value={fieldName}
            onTextChange={(text) => {
              setFieldName(text);
              setFieldError('');
            }}
          />
        </div>
        {fieldError && <div className="text-red-500 text-sm px-4 mt-2">See above error</div>}
        <div className="flex justify-between p-4 w-full">
          <AppButton text="Close" onClick={handleCloseModal} type="TERTIARY" />
          <AppButton text="Submit" onClick={handleSubmit} />
        </div>
      </div>
    </Modal>
  );
};

export default AddStepModal;
